import { TableCell, TableRow, Typography } from "@mui/material";

import { contactTypeColorFor } from "../../../cm/Dashboard/FullPages/ClientDetail/utils/contactTypeBadges";
import FormatPhoneNumber from "../../../global/FormatPhoneNumber";
import PermissionWrapper from "../../../global/PermissionWrapper";
import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";
import ContactTypeDot from "../../../ui library/components/indicators/ContactTypeDot";
import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";

export default function ContactsTableItem({
  contact,
  fieldOptions = [],
  contactTypeColors = {},
  permissions,
  editHandler,
  deleteHandler,
}) {
  const contactData = {
    ...contact,
    relationType: fieldOptions.find((fieldOption) => fieldOption.key === contact?.relationType),
  };

  return (
    <TableRow key={contact?.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell align="left">
        <Typography className="text-sm font-normal">{contactData?.name}</Typography>
      </TableCell>
      <TableCell align="left">
        <div className="flex items-center gap-1.5">
          <ContactTypeDot color={contactTypeColorFor(contactTypeColors, contact?.relationType)} />
          <Typography className="text-sm font-normal">
            {contactData?.relationType?.value}
          </Typography>
        </div>
      </TableCell>
      <TableCell align="left">
        {<Typography className="text-sm font-normal">{contactData?.companyName}</Typography>}
      </TableCell>
      <TableCell align="left">
        {
          <Typography className="text-sm font-normal">
            {FormatPhoneNumber(contactData?.phone)}
          </Typography>
        }
      </TableCell>
      <TableCell align="left">
        {<Typography className="text-sm font-normal">{contactData?.email}</Typography>}
      </TableCell>
      <TableCell align="left">
        <div className="flex w-full flex-row gap-4">
          <PermissionWrapper permission={permissions.EDIT}>
            <CustomIconButton
              iconVisible={true}
              CustomIcon={
                <Svg
                  name={SvgEnum.HisEdit3}
                  onClick={() => editHandler(contactData)}
                  color={HNSColors.primary[500]}
                />
              }
            />
          </PermissionWrapper>
          <PermissionWrapper permission={permissions.DELETE}>
            <CustomIconButton
              iconVisible={true}
              CustomIcon={
                <Svg
                  name={SvgEnum.HisX}
                  color={HNSColors.failure[500]}
                  onClick={() => deleteHandler(contact.id)}
                  sx={{
                    height: "24px",
                    width: "24px",
                  }}
                />
              }
            />
          </PermissionWrapper>
        </div>
      </TableCell>
    </TableRow>
  );
}
